import { Box, Typography, makeStyles, useTheme } from '@material-ui/core';
import { IncomingMessageIcon } from '../../icons/IncomingMessageIcon';
import { WittyIcon } from '../../icons/WittyIcon';
import { WittyToolCall } from '@agilelab/plugin-wb-witty-common';
import { ToolActivity } from '../ToolActivity';

const useStyles = makeStyles(
  theme => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: theme.spacing(1),
      alignItems: 'auto',
    },
    avatar: {
      width: '24px',
      height: '24px',
    },
    iconWrapper: {
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(4),
    },
    toolActivityWrapper: {
      paddingTop: 0,
    },
    responderName: {
      marginLeft: theme.spacing(0.5),
      fontSize: '0.8125rem',
    },
  }),
  { name: 'IncomingMessage' },
);

interface IncomingMessageProps {
  statusText?: string;
  responderLabel?: string;
  toolCalls?: WittyToolCall[];
}

export const IncomingMessage = ({
  statusText,
  responderLabel,
  toolCalls,
}: IncomingMessageProps) => {
  const theme = useTheme();
  const classes = useStyles();
  const agentLabel =
    responderLabel && responderLabel.toLocaleUpperCase() !== 'WITTY'
      ? responderLabel
      : undefined;
  const renderActivity = () => {
    if (toolCalls && toolCalls.length > 0) {
      const hasRunningTool = toolCalls.some(
        toolCall => toolCall.status === 'running',
      );
      return (
        <>
          <ToolActivity toolCalls={toolCalls} active />
          {!hasRunningTool && statusText && (
            <Typography variant="body2" color="textSecondary">
              {statusText}
            </Typography>
          )}
        </>
      );
    }
    if (statusText) {
      return (
        <Typography variant="body2" color="textSecondary">
          {statusText}
        </Typography>
      );
    }
    return <IncomingMessageIcon />;
  };

  return (
    <Box className={classes.container}>
      <Box display="flex" alignItems="center" style={{ gap: theme.spacing(1) }}>
        <WittyIcon style={{ color: theme.palette.witboostLogo }} />

        <Typography style={{ fontWeight: 600 }} variant="body2">
          WITTY
          {agentLabel && (
            <span className={classes.responderName}>({agentLabel})</span>
          )}
          :
        </Typography>
      </Box>
      <Box
        className={`${classes.iconWrapper} ${
          toolCalls && toolCalls.length > 0 ? classes.toolActivityWrapper : ''
        }`}
      >
        {renderActivity()}
      </Box>
    </Box>
  );
};
